import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarTextComponent } from './avatar-text/avatar-text.component';



@NgModule({
  declarations: [
    AvatarTextComponent
  ],
  exports: [
    AvatarTextComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ImageModule { }
